import { PlanoChave } from "../types/billing.types";

export type IntervaloBilling = "month" | "year";

export interface TierPago {
  id: "premium" | "profissional";
  name: string;
  highlight: boolean;
  features: string[];
  chaves: Record<IntervaloBilling, PlanoChave>;
}

export const INTERVALOS_BILLING: { id: IntervaloBilling; label: string; suffix: string }[] = [
  { id: "month", label: "Mensal", suffix: "/mês" },
  { id: "year", label: "Anual", suffix: "/ano" },
];

export const TIERS_PAGOS: TierPago[] = [
  {
    id: "premium",
    name: "Premium",
    highlight: true,
    features: [
      "Até 15 pacotes de cirurgia",
      "Até 15 pacotes de OPME",
      "Voz-para-Texto (STT)",
      "Leitor de OCR",
    ],
    chaves: { month: "premium_mensal", year: "premium_anual" },
  },
  {
    id: "profissional",
    name: "Profissional",
    highlight: false,
    features: [
      "Tudo do Premium",
      "Pacotes de cirurgia e OPME ilimitados",
      "Suporte prioritário",
    ],
    chaves: { month: "profissional_mensal", year: "profissional_anual" },
  },
];

export function formatarPrecoPlano(valorCentavos: number, moeda = "brl"): string {
  const amount = valorCentavos / 100;
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: moeda.toUpperCase(),
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
  }).format(amount);
}

/** Desconto do anual sobre 12 mensalidades, em % inteiro. Vale o menor entre
 *  os planos (nunca anuncia mais do que o plano menos descontado dá). Null se
 *  faltar preço ou não houver desconto. Tudo vem do Stripe: mudar o preço lá
 *  muda o selo sozinho. */
export function descontoAnualPercentual(precos: Record<string, { valor_centavos: number }>): number | null {
  const percentuais = TIERS_PAGOS.map((tier) => {
    const mensal = precos[tier.chaves.month]?.valor_centavos;
    const anual = precos[tier.chaves.year]?.valor_centavos;
    return mensal && anual ? Math.round((1 - anual / (mensal * 12)) * 100) : null;
  });
  if (percentuais.some((p) => p === null)) return null;
  const menor = Math.min(...(percentuais as number[]));
  return menor > 0 ? menor : null;
}

/** Equivalente mensal de um preço anual, em centavos. */
export function equivalenteMensalCentavos(valorAnualCentavos: number): number {
  return Math.round(valorAnualCentavos / 12);
}
